import { CalendarBlank, Clock } from "@phosphor-icons/react";
import { AccountDrawer } from "../../components/shared/account/AccountUI.tsx";
import { notificationTypeLabel, type NotificationRecord } from "./notificationApi.ts";
import { safeNotificationHtml } from "./notificationHtml.ts";
import { getLocale, t } from "../store-language/i18n.ts";
import "./notifications.css";

export function notificationDate(value: string, admin = false): string {
  return new Intl.DateTimeFormat(admin ? "fa-IR" : getLocale(), { dateStyle: "short", timeStyle: "short" }).format(new Date(value));
}

export default function NotificationDetail({ notification, onClose, admin = false }: {
  notification: NotificationRecord | null; onClose: () => void; admin?: boolean;
}) {
  function label(value: string) { return admin ? value : t(value); }
  return (
    <AccountDrawer
      title={notification?.title || label("جزئیات اعلان")}
      open={Boolean(notification)}
      onClose={onClose}
      width="min(100vw, clamp(34rem, 55vw, 55rem))"
      placement={admin ? "right" : undefined}
      headerActions={notification ? (
        <span className={`notification-detail__status notification-detail__status--${notification.readAt ? "read" : "unread"}`}>
          {notification.readAt ? label("خوانده شده") : label("خوانده نشده")}
        </span>
      ) : null}
    >
      {notification ? (
        <section className="notification-detail">
          <div className="notification-detail__metadata notification-detail__metadata--primary">
            {[
              [label("عنوان"), notification.title],
              [label("نوع اعلان"), label(notificationTypeLabel(notification.type))],
              ...(admin ? [["گیرنده", notification.recipientName || ""], ["نمایندگی", notification.agencyTitle || ""], ["شرکت", notification.companyTitle || ""]] : []),
            ].map(function ([name, value]) {
              return (
                <div className="notification-detail__metadata-item" key={name}>
                  <span className="notification-detail__metadata-label">{name}:</span>
                  <strong className="notification-detail__metadata-value"><bdi>{value}</bdi></strong>
                </div>
              );
            })}
          </div>
          <div className="notification-detail__metadata notification-detail__metadata--dates">
            <div className="notification-detail__metadata-item">
              <CalendarBlank size={16} />
              <span>{label("تاریخ ارسال")}:</span>
              <bdi>{notificationDate(notification.sentAt, admin)}</bdi>
            </div>
            {notification.readAt ? (
              <div className="notification-detail__metadata-item">
                <Clock size={16} />
                <span>{label("تاریخ خواندن")}:</span>
                <bdi>{notificationDate(notification.readAt, admin)}</bdi>
              </div>
            ) : null}
          </div>
          <h2 className="notification-detail__section-title">{label("محتوای پیام")}</h2>
          <div
            className="notification-detail__message"
            lang={notification.languageCode}
            dir={notification.languageCode === "en" ? "ltr" : "rtl"}
            dangerouslySetInnerHTML={{ __html: safeNotificationHtml(notification.message, true) }}
          />
        </section>
      ) : null}
    </AccountDrawer>
  );
}
